function changeFindAContactCategory(event) {
    if (dragging) return;

    var target = event.target.closest(".find-a-contact .tabs a");
    if (target) {
        event.preventDefault();
        event.stopPropagation();
        handleCategoryClick(target);
    }
}

function handleCategoryClick(target) {
    window.location.hash = target.getAttribute('href');
    if (!target.classList.contains("active") && document.querySelector(".find-a-contact .tabs a.active")) {
        document.querySelector(".find-a-contact .tabs a.active").classList.remove("active");
        target.classList.add("active");

        document.querySelector(".find-a-contact .tab-content .tab.active").classList.remove("active");
        document.querySelector(".find-a-contact .tab-content .tab" + target.getAttribute("href")).classList.add("active");

        let elemRect = document.querySelector(".find-a-contact .tab-content").getBoundingClientRect().top;
        let bodyRect = document.body.getBoundingClientRect().top;
        let offset = elemRect - bodyRect;

        if (window.widthREMs >= breakpointToDesktopNav) {
            window.scrollTo(0, (offset - 130));
        } else {
            window.scrollTo(0, (offset - 80));
        }
    }
}

let hash = window.location.hash;
if(hash) {
    let card = document.querySelector(`a[href="${hash}"]`);
    if(card) {
        handleCategoryClick(card);
    }
}

document.addEventListener("click", changeFindAContactCategory);
document.addEventListener("touchend", changeFindAContactCategory);